import { GiftCard } from 'services/checkout-service/models';

export const getGiftCardDeductions = (payableTotalAmount: number, giftCards: GiftCard[]) => {
  let localTotal = payableTotalAmount;
  const usableGiftCards = giftCards.filter(({ balance }) => Boolean(balance && balance > 0));
  if (usableGiftCards.length <= 0) return undefined;

  return usableGiftCards.map(({ last4, balance, token }) => {
    const giftCardBalanceAmount = balance || 0;
    const amountUsedFromGiftCard = Math.min(localTotal, giftCardBalanceAmount);
    localTotal = localTotal - amountUsedFromGiftCard;

    return {
      token,
      last4,
      amountUsedFromGiftCard,
      balance,
    }
  });
}
